"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpUsercontrol = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const gettext_1 = require("@integro/gettext");
const usercontrol_html_1 = __importDefault(require("./usercontrol.html"));
let ItpUsercontrol = class ItpUsercontrol extends vue_property_decorator_1.Vue {
    loading;
    reloading;
    loadingSpinner;
    loaded;
    renderOnlyWhenLoadCompleted;
    error;
    data() {
        return {
            msgReload: (0, gettext_1.pgettext)('UserControlButton', 'Reload'),
            msgReloading: (0, gettext_1.pgettext)('UserControlMessage', 'Reloading...'),
        };
    }
};
exports.ItpUsercontrol = ItpUsercontrol;
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpUsercontrol.prototype, "loading", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpUsercontrol.prototype, "reloading", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpUsercontrol.prototype, "loadingSpinner", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpUsercontrol.prototype, "loaded", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false }),
    __metadata("design:type", Boolean)
], ItpUsercontrol.prototype, "renderOnlyWhenLoadCompleted", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Error)
], ItpUsercontrol.prototype, "error", void 0);
exports.ItpUsercontrol = ItpUsercontrol = __decorate([
    (0, vue_property_decorator_1.Component)({ template: usercontrol_html_1.default })
], ItpUsercontrol);
//# sourceMappingURL=usercontrol.js.map